/* @flow */

let initialState: { loading: boolean } = { loading: true };
export function venue(state: Object = initialState, action:Object) {
    if(action.type === "FETCH_EVENT") {
        let newState = {...state, loading: false};
        newState.venues = {};
        for (const id in action.data.attributes.events) {
            newState.venues[id] = action.data.attributes.events[id].venue;
        }
        return newState;
    } else {
        return state;
    }
}
